export const HOST_DEFAULT_FEATURE_FLAG_CONFIGS = {
  configs: {
    featureFlagConfigs: {
      translations: true,
      recordWidgets: true,
      useTypeBasedApi: false,
    },
    interopFlags: {
      entities: false,
    },
    uiControlsConfigs: {
      entityList: {
        table: {
          columns: {
            icon: { visible: true },
            name: { visible: true },
            description: { visible: true },
            associated_objects: { visible: true },
            created_time: { visible: true },
          },
        },
      },
    },
  },
};

export default {
  manageTranslation: true, // to be activated after API and message channel Integration
  exportRecordsEnabled: false,
};
